import {Box} from '@mantine/core';
import {DevelopmentExperiencePromo} from '../../../features/promoPopup/components/DevelopmentExperiencePromo';
import {GmailPromo} from '../../../features/promoPopup/components/GmailPromo';
import {MobilePromo} from '../../../features/promoPopup/components/MobilePromo';
import {OffereePromo} from '../../../features/promoPopup/components/OffereePromo';
import {ProfilePromo} from '../../../features/promoPopup/components/ProfilePromo';
import {ScoutPromo} from '../../../features/promoPopup/components/ScoutPromo';
import {useHandlePromoPopup} from '../../services/useHandlePromoPopup';

export const Popup: React.FC = () => {
  const {data, user, isOpen, closePopup, isShow} = useHandlePromoPopup();

  let content;
  if (data?.ok) {
    switch (data.value?.messageType) {
      case 'mobile_promo': {
        content = (
          <MobilePromo
            closePopup={() => {
              closePopup(data.value?.messageType);
            }}
          />
        );
        break;
      }

      case 'gmail_promo': {
        content = (
          <GmailPromo
            closePopup={() => {
              closePopup(data.value?.messageType);
            }}
          />
        );
        break;
      }

      case 'profile_prompt': {
        content = (
          <ProfilePromo
            closePopup={() => {
              closePopup(data.value?.messageType);
            }}
          />
        );
        break;
      }

      case 'scout_on_promo': {
        content = user && (
          <ScoutPromo
            closePopup={() => {
              closePopup(data.value?.messageType);
            }}
            userName={user.familyName}
          />
        );

        break;
      }

      case 'offeree_survey_promo': {
        content = (
          <OffereePromo
            closePopup={() => {
              closePopup(data.value?.messageType);
            }}
          />
        );
        break;
      }

      case 'development_experience_promo': {
        content = (
          <DevelopmentExperiencePromo
            closePopup={() => {
              closePopup(data.value?.messageType);
            }}
          />
        );
        break;
      }

      default: {
        content = <></>;
      }
    }
  }

  return (
    <>
      {/* isOpenはポップアップを閉じているかを管理するためのフラグ
      isShowはPC画面や特定のURLでのみポップアップを表示するためのフラグ */}
      {data?.ok &&
        data.value.messageType !== '' &&
        isOpen &&
        isShow &&
        user && (
          <Box className="pc:bg-background-1 pc:pt-20 pc:my-0 mt-12 pc:mx-0 mx-16">
            <Box className="bg-white mx-auto pc:my-0 pc:max-w-[1200px] py-12 px-16 pc:mb-0 mb-[-20px] relative overflow-hidden items-center rounded-[8px] shadow-card">
              {content}
            </Box>
          </Box>
        )}
    </>
  );
};
